__turbopack_context__.v({
  "icon": "ThemeToggle-module__uZAifq__icon",
  "toggle": "ThemeToggle-module__uZAifq__toggle",
});
